<template>
  <v-card flat class="pa-5">
    <v-overlay :value="loading" absolute>
      <atom-spinner indeterminate size="48" color="primary" />
    </v-overlay>

    <div>
      <v-row>
        <!-- تصویر محصول -->
        <v-col cols="12" md="12" class="d-flex align-center gap-4 pa-3 bg-grey-lighten-4 rounded-lg mb-4">
          <div class="d-flex flex-column flex-grow-1">
            <span class="text-subtitle-2 font-weight-bold mb-1">تصویر محصول</span>
            <pic-selector
              :field.sync="qrInnerData.photo.profile"
              :edit-img="false"
              :edit-name="false"
              one-pic
              single
            />
          </div>
        </v-col>

        <!-- تصویر پس‌زمینه -->
        <v-col cols="12" md="12" class="d-flex align-center gap-4 pa-3 bg-grey-lighten-4 rounded-lg mb-4">
          <div class="d-flex flex-column flex-grow-1">
            <span class="text-subtitle-2 font-weight-bold mb-1">تصویر پس‌زمینه</span>
            <pic-selector
              :field.sync="qrInnerData.photo.background"
              :edit-img="false"
              :edit-name="false"
              one-pic
              single
            />
          </div>
        </v-col>

        <!-- نام مجموعه -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="formLabel.name.text"
            append-icon="mdi-domain"
            dense
            outlined
            counter="50"
            label="نام مجموعه"
            hint="نام کمپانی یا برند خود را وارد کنید"
          />
        </v-col>

        <!-- برند -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="formLabel.brand.text"
            append-icon="mdi-tag-outline"
            dense
            outlined
            counter="50"
            label="برند محصول"
          />
        </v-col>

        <!-- نام محصول -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="formLabel.labelName.text"
            append-icon="mdi-basket"
            dense
            outlined
            counter="50"
            label="نام محصول"
            hint="عنوان اصلی لیبل محصول"
          />
        </v-col>

        <!-- قیمت تولید -->
        <v-col cols="12" md="6" class="d-flex align-center">
          <price-input
            v-model="formLabel.price.text"
            label="قیمت تولید"
            dense
            outlined
          />
        </v-col>

        <!-- قیمت مصرف‌کننده -->
        <v-col cols="12" md="6" class="d-flex align-center">
          <price-input
            v-model="formLabel.bPrice.text"
            label="قیمت مصرف کننده"
            dense
            outlined
          />
        </v-col>

        <!-- قیمت فروشگاه -->
        <v-col cols="12" md="6" class="d-flex align-center">
          <price-input
            v-model="formLabel.cPrice.text"
            label="قیمت فروشگاه"
            dense
            outlined
          />
        </v-col>

        <!-- درصد تخفیف -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="formLabel.discount.text"
            label="درصد تخفیف"
            type="number"
            outlined
            dense
            append-icon="mdi-sale"
          />
        </v-col>

        <!-- توضیحات محصول -->
        <v-col cols="12">
          <v-textarea
            v-model="formLabel.discriptions.text"
            label="توضیحات محصول"
            outlined
            dense
            rows="3"
            counter="2000"
          />
        </v-col>
      </v-row>

      <!-- دکمه‌های عملیات -->
      <div class="d-flex justify-space-between mt-4">
        <v-btn class="btn-delete rounded-lg" @click="$emit('close')">
          <v-icon left>mdi-close</v-icon>
          انصراف
        </v-btn>
        <v-spacer />
        <v-btn :loading="saving" class="btn-get-code rounded-lg" @click="saveProduct">
          <v-icon left>mdi-content-save</v-icon>
          ذخیره تغییرات
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import customDatePicker from "../../../core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import PriceInput from "../../../core/plugins/TitleRibbon/pages/pickers/priceInput.vue";
import PicSelector from "../../components/UploadCenter/picSelector.vue";

export default {
  name: "EditPhysicalProductModal",
  components: {
    AtomSpinner,
    customDatePicker,
    PriceInput,
    PicSelector,
  },
  props: {
    productData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    saving: false,
    qrRawRecord: null,
    qrTheme: "priceLabelTheme",
    qrInnerData: {
      photo: {
        profile: null,
        background: null,
        headBackground: "",
        gallery: [{ images: [] }],
      },
      profile: null,
      pallete: {},
      order: [],
      label: {},
    },
    formLabel: {
      name: { text: "", line: false },
      brand: { text: "", line: false },
      labelName: { text: "", line: false },
      price: { text: "", line: false },
      bPrice: { text: "", line: false },
      cPrice: { text: "", line: false },
      discount: { text: "", line: false },
      production: { text: "", line: false },
      expiration: { text: "", line: false },
      discriptions: { text: "", line: false },
    },
  }),
  mounted() {
    this.fetchDetails();
  },
  methods: {
    async fetchDetails() {
      this.loading = true;
      try {
        const domainRaw = this.productData.domain?.name || "qrland.in/";
        const domain = domainRaw.endsWith("/") ? domainRaw : `${domainRaw}/`;
        const identifier = (this.productData.identifier || "").replace(/^\/+/, "");

        const res = await this.$api.get(`${this.$qrApi}/v1/testQr/find/${domain}${identifier}`);

        const raw = res.data.data;
        this.qrRawRecord = raw;

        const parsed = typeof raw.data === "string" ? JSON.parse(raw.data) : raw.data;
        this.qrTheme = parsed?.theme || raw?.theme || "priceLabelTheme";
        this.qrInnerData = parsed?.data || {};

        // مقداردهی بخش تصویر
        const profileImg = this.qrInnerData?.photo?.profile || this.qrInnerData?.profile || null;
        const backgroundImg = this.qrInnerData?.photo?.background || null;

        this.$set(this.qrInnerData, "photo", {
          headBackground: this.qrInnerData?.photo?.headBackground || "",
          gallery: this.qrInnerData?.photo?.gallery || [{ images: [] }],
          profile: profileImg,
          background: backgroundImg,
        });
        this.$set(this.qrInnerData, "profile", profileImg);

        // واکشی لیبل‌ها
        if (this.qrInnerData.label) {
          const rawLabel = this.qrInnerData.label;
          Object.keys(this.formLabel).forEach((key) => {
            if (rawLabel[key] !== undefined && rawLabel[key] !== null) {
              const val = rawLabel[key];
              let textVal = "";
              let lineVal = false;

              if (typeof val === "object" && val !== null) {
                textVal = val.text !== null && val.text !== undefined ? String(val.text) : "";
                lineVal = Boolean(val.line);
              } else {
                textVal = String(val);
              }

              this.$set(this.formLabel, key, {
                text: textVal,
                line: lineVal,
              });
            }
          });
        }
      } catch (err) {
        this.$toast.error("خطا در دریافت اطلاعات محصول");
      } finally {
        this.loading = false;
      }
    },

    async saveProduct() {
      this.saving = true;
      try {
        const labelPayload = {};
        Object.keys(this.formLabel).forEach((key) => {
          const item = this.formLabel[key];
          let text = item.text;
          if (["price", "bPrice", "cPrice", "discount"].includes(key) && text !== "") {
            text = Number(text) || text;
          }
          labelPayload[key] = {
            text: text,
            line: !!item.line,
          };
        });

        const updatedProfile = this.qrInnerData.photo?.profile || null;

        const updatedDataPayload = {
          ...this.qrInnerData,
          profile: updatedProfile,
          photo: {
            ...this.qrInnerData.photo,
            profile: updatedProfile,
          },
          label: {
            ...this.qrInnerData.label,
            ...labelPayload,
          },
        };

        const formData = new FormData();
        formData.append("type", this.qrRawRecord?.type || "pricelabel");
        formData.append("qrType", "dynamic");
        formData.append("title", this.formLabel.labelName.text || this.qrRawRecord?.title || "");
        formData.append("domain", this.qrRawRecord?.domain?.name || this.productData.domain?.name || "qrland.in");
        formData.append("identifier", this.qrRawRecord?.identifier || this.productData.identifier);
        formData.append("qr_id", this.qrRawRecord?.id || this.qrRawRecord?.qrId || this.productData.id);
        formData.append("_method", "PUT");
        formData.append(
          "data",
          JSON.stringify({
            theme: this.qrTheme,
            data: updatedDataPayload,
          })
        );

        await this.$api.post(`${this.$qrApi}/v1/testQr/update`, formData);

        this.$toast.success("محصول با موفقیت به‌روزرسانی شد");
        this.$emit("saved");
      } catch (err) {
        this.$toast.error("خطا در بروزرسانی اطلاعات محصول");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
